module.exports = __webpack_public_path__ + "img/preview-4.7b8d2e9f.webp";